<template>
  <div class="modal-card">
    <header class="modal-card-head" />
    <section class="modal-card-body">
      <div class="template-options-wrapper">
        <b-button
          type="is-white"
          @click="templateOffset--"
          icon-right="chevron-up"
          :disabled="decrementDisabled"
        />
        <div
          v-for="template in showingTemplates"
          :key="template.id"
          class="template-options"
        >
          <div class="thumbnail-small">
            <img :src="cloud(template.cover)" :alt="template.title" />
            <div class="thumbnail-small-overlay" @click="selected = template">
              {{ template.title }}
            </div>
          </div>
        </div>
        <b-button
          type="is-white"
          @click="templateOffset++"
          icon-right="chevron-down"
          :disabled="incrementDisabled"
        />
      </div>
      <div class="h-pano-wrapper">
        <h-pano
          v-if="selected"
          :source="cloud(selected.cover)"
          :controlButtons="[]"
          :disableZoom="true"
        />
      </div>
    </section>

    <footer class="modal-card-foot" style="justify-content: flex-end;">
      <div class="buttons modal-buttons">
        <b-button class="is-white" size="is-large" @click="$emit('close')"
          >Cancel</b-button
        >
        <b-button class="is-primary" size="is-large" @click="select"
          >Select</b-button
        >
      </div>
    </footer>
  </div>
</template>

<script>
import HPano from "@/components/spaces/HPano.vue";

const NUM_TEMPLATES_SHOWING = 3; //Number of small template thumbnails showing

export default {
  components: {
    HPano,
  },
  props: ["templates"],
  data() {
    return {
      selected: undefined,
      templateOffset: 0,
    };
  },
  async created() {
    this.selected = this.templates[0];
  },
  methods: {
    select() {
      if (!this.selected) return;
      this.$emit("selected", this.selected);
      this.$emit("close");
    },
  },
  computed: {
    showingTemplates() {
      if (!this.templates) return [];

      const { length } = this.templates;
      const start = this.templateOffset;
      const end =
        NUM_TEMPLATES_SHOWING > length ? length : start + NUM_TEMPLATES_SHOWING;
      return this.templates.slice(start, end);
    },
    decrementDisabled() {
      return this.templateOffset <= 0;
    },
    incrementDisabled() {
      if (!this.templates) return true;
      return (
        this.templateOffset + NUM_TEMPLATES_SHOWING >= this.templates.length
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";

.h-pano {
  width: 100%;
  height: 100%;
}

.h-pano-wrapper {
  height: 400px;
  border-radius: $radius-large;
  overflow: hidden;
  mask-image: -webkit-radial-gradient(white, black);
  -webkit-mask-image: -webkit-radial-gradient(white, black);
}

.modal-card-body {
  display: grid;
  grid-template-columns: auto;
  @media screen and (min-width: (500px)) {
    grid-template-columns: 180px auto;
  }
  gap: 24px;
}

.thumbnail-large {
  height: 100%;
}

.thumbnail-small {
  display: grid;
  cursor: pointer;
  > * {
    border-radius: $radius-large;
    grid-column-start: 1;
    grid-row-start: 1;
  }
}

.thumbnail-small-overlay {
  display: grid;
  align-items: center;
  justify-items: center;
  color: white;
  background: rgba(128, 128, 128, 0.6);
}

.template-options-wrapper {
  display: grid;
  grid-template-columns: auto;
  gap: 4px;
}
</style>
